import { GEOSERVER_BASE_URL } from "../../../axios-config.js";

export const TENEMENTS_LAYER =
  (typeof process !== "undefined" && process.env && process.env.REACT_APP_TENEMENTS_LAYER) ||
  "inventum-public:au-wa-live-pending";

const TENEMENTS_TMS_GRIDSET =
  (typeof process !== "undefined" && process.env && process.env.REACT_APP_TENEMENTS_TMS_GRIDSET) ||
  "EPSG%3A900913";

const TENEMENTS_TMS_FORMAT =
  (typeof process !== "undefined" && process.env && process.env.REACT_APP_TENEMENTS_TMS_FORMAT) ||
  "png8";

export function createTenementsTileUrl() {
  return `${GEOSERVER_BASE_URL}/gwc/service/tms/1.0.0/${TENEMENTS_LAYER}@${TENEMENTS_TMS_GRIDSET}@${TENEMENTS_TMS_FORMAT}/{z}/{x}/{y}.${TENEMENTS_TMS_FORMAT}`;
}

export function createTenementInfoUrl(latlng) {
  const params = new URLSearchParams({
    SERVICE: "WMS",
    VERSION: "1.1.1",
    REQUEST: "GetFeatureInfo",
    QUERY_LAYERS: TENEMENTS_LAYER,
    LAYERS: TENEMENTS_LAYER,
    INFO_FORMAT: "application/json",
    FEATURE_COUNT: "50",
    X: "50",
    Y: "50",
    SRS: "EPSG:4283",
    WIDTH: "101",
    HEIGHT: "101",
    BBOX: `${latlng.lng},${latlng.lat},${latlng.lng + 0.01},${latlng.lat + 0.01}`,
  });

  return `${GEOSERVER_BASE_URL}/wms?${params.toString()}`;
}

export function createTenementHolderCsvUrl() {
  const params = new URLSearchParams({
    SERVICE: "wfs",
    VERSION: "1.1.1",
    REQUEST: "GetFeature",
    TYPENAME: TENEMENTS_LAYER,
    propertyname: "HOLDER1",
    outputformat: "csv",
  });

  return `${GEOSERVER_BASE_URL}/wfs?${params.toString()}`;
}

export function createTenementHolderFeatureUrl(holder) {
  const params = new URLSearchParams({
    SERVICE: "wfs",
    VERSION: "1.1.1",
    REQUEST: "GetFeature",
    TYPENAME: TENEMENTS_LAYER,
    CQL_FILTER: `HOLDER1='${holder.replace(/'/g, "''")}'`,
    outputformat: "application/json",
  });

  return `${GEOSERVER_BASE_URL}/wfs?${params.toString()}`;
}
